export default {
    PUBLIC: 'public',
    PAGES: 'public/pages',
    BACKEND: 'backend',
    SCHEMAS: '.schemas',
    STYLES: 'styles',
    COMPONENTS: 'components'
}
